import axios from "axios";

const baseURL =
  process.env.VUE_APP_API_BASE_URL || "http://localhost:8008/api";

const client = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    Accept: "application/json"
  }
});

export default {
  /**
   * Request a login OTP to be sent to the member's registered email.
   * @param {Object} payload
   * @param {number} payload.comId - company id
   * @param {number} payload.mId - member id
   * @returns response data: { status, success, message, referenceCode }
   */
  async requestOtp({ comId, mId }) {
    return await client.post("otp/admin-request", { comId, mId });
  },

  /**
   * Verify a login OTP code.
   * @param {Object} payload
   * @param {number} payload.comId - company id
   * @param {number} payload.mId - member id
   * @param {number|string} payload.otpCode - the code entered by the user
   * @returns response data: { status, success, message }
   */
  async verifyOtp({ comId, mId, otpCode, referenceCode }) {
    return await client.post("otp/admin-verify", { comId, mId, otpCode, referenceCode });
  }
};
